<template>
    <button type="button" class="paybtn interactable" ref="payBtnElement" />
</template>

<script setup lang="ts">
    import { PayButton } from "@/app/elements/PayButton";
    import { onMounted, ref, watch } from "vue";

    const props = defineProps<{
        action: string;
        amount?: number | string;
        disabled?: boolean;
    }>();

    let payBtn: PayButton;
    const payBtnElement = ref<HTMLElement | null>(null);

    onMounted(() => {
        payBtn = new PayButton(props.action, $(payBtnElement.value!));
        if (props.disabled) {
            payBtn.setDisabled();
        }

        if (props.amount) {
            payBtn.setAmount(props.amount);
        }
    });

    watch(
        () => props.disabled,
        (disabled) => {
            if (disabled) {
                payBtn.setDisabled();
            } else {
                payBtn.setEnabled();
            }
        }
    );

    watch(
        () => props.amount,
        (amount) => {
            if (amount !== undefined) {
                payBtn.setAmount(amount);
            }
        }
    );
</script>
